const linksData = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "What We Do",
    url: "/whatwedo",
  },
  {
    title: "Resources",
    url: "/resources",
    sublink: [
      {
        title: "Covid-19",
        url: "resources/hiv-covid-19",
      },
      {
        title: "Financial Report",
        url: "resources/financial-report",
      },
    ],
  },
  {
    title: "Get Involved",
    url: "/getinvolved",
  },
  {
    title: "About Us",
    url: "/aboutus",
  },
];

export default linksData;
